/*
 * Description:
 * ---------------------
 * The notabox-server routes behind the Approvers, approval, Agent Rules and
 * Changes screens (server/pkg/authority, server/pkg/meshctl), and one way to
 * call them: JSON both ways under the person's session cookie, a refusal's
 * own sentence as the error.
 * A route an older server does not serve, a 404 or 501 with no sentence of
 * its own, throws NotServed, which each screen shows as the console's
 * feature-unavailable notice.
 *
 * ! file components/approvalApi.js
 */
import { fetchWithTimeout } from "../utils/fetchWithTimeout";

const e = encodeURIComponent;
const one = (id) => `/mesh/approvals/${e(id)}`;

export const ROUTES = {
  domains: "/domains",
  approvers: (customer) => `/mesh/approvers?customer=${e(customer)}`,
  passkeyBegin: "/mesh/approvers/passkeys/begin",
  passkeyFinish: "/mesh/approvers/passkeys/finish",
  waiting: "/mesh/approvals?status=waiting",
  approval: one,
  approveBegin: (id) => `${one(id)}/begin`,
  approveFinish: (id) => `${one(id)}/finish`,
  decline: (id) => `${one(id)}/decline`,
  task: (id) => `/mesh/tasks/${e(id)}`,
  freezes: (customer) => `/mesh/freeze?customer=${e(customer)}`,
  freeze: "/mesh/freeze",
  unfreeze: "/mesh/unfreeze",
  rules: (customer) => `/mesh/rules?customer=${e(customer)}`,
  nodes: "/nodes",
  controller: "/mesh/controller",
  changeKinds: "/mesh/changes/kinds",
  changes: (customer) => `/mesh/changes?customer=${e(customer)}`,
  startChange: "/mesh/changes",
  change: (id) => `/mesh/changes/${e(id)}`,
  stopChange: (id) => `/mesh/changes/${e(id)}/stop`,
  predict: "/mesh/predictions",
  prediction: (id) => `/mesh/predictions/${e(id)}`,
  supervisor: (customer) => `/mesh/supervisor?customer=${e(customer)}`,
  chain: "/mesh/chain",
  chainRuns: (customer) => `/mesh/chain/runs?customer=${e(customer)}`,
  chainRun: (id) => `/mesh/chain/runs/${e(id)}`,
};

export class NotServed extends Error {}

/* ask sends body by POST, or by method where a route takes it so (the
   agents' switch, PUT); without one it reads. */
export async function ask(serverApiUrl, path, body, method = body ? "POST" : "GET") {
  const res = await fetchWithTimeout(serverApiUrl(path), {
    method,
    credentials: "same-origin",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  }, 15000).catch(() => null);
  if (!res) throw new Error("The Weavian server did not answer.");
  const out = await res.json().catch(() => ({}));
  if ((res.status === 404 || res.status === 501) && !out.error) throw new NotServed();
  if (!res.ok) throw new Error(out.error || `The server refused (HTTP ${res.status}).`);
  return out;
}
